import { ReactElement } from "react";
import { Card } from "../../../../../components";

interface NonExpandableCardProps {
  title?: string;
  children: ReactElement | string;
  className?: string;
}

export const NonExpandableCard = ({
  title,
  children,
  className = "",
}: NonExpandableCardProps) => {
  return (
    <Card className={`relative p-[20px] ${className}`}>
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="watermark"></div>
      </div>

      <div className="flex flex-col gap-7 items-stretch w-full">
        {title && <h2 className="font-bold">{title}</h2>}
        {children}
      </div>
    </Card>
  );
};
